import { onMounted, onUnmounted, ref } from 'vue';

/**
 * Composable for detecting hover capability using CSS media queries
 * Detects if the primary input mechanism can hover (mouse/trackpad vs touch)
 * Works for iPads with Magic Keyboard, desktop, and touch-only devices
 *
 * @returns {object} Object containing hover detection utility
 */
export function useHover() {
  const hasHover = ref(false);

  let mediaQuery: MediaQueryList | undefined;

  const updateHover = (event: MediaQueryListEvent) => {
    hasHover.value = event.matches;
  };

  onMounted(() => {
    if (typeof window !== 'undefined') {
      // Check for both hover capability and fine pointer (mouse/trackpad vs touch)
      mediaQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
      hasHover.value = mediaQuery.matches;
      mediaQuery.addEventListener('change', updateHover);
    }
  });

  onUnmounted(() => {
    if (mediaQuery) {
      mediaQuery.removeEventListener('change', updateHover);
    }
  });

  return { hasHover };
}
